export const isString = (value: unknown): value is string => typeof value === 'string';

export const compareStrings = (s1?: string, s2?: string): number => {
  if (s1 && s2) {
    return s1.localeCompare(s2);
  }

  if (!s1) return -1;
  if (!s2) return 1;

  return 0;
};
